import React from 'react'

const Cell = props => {
  return (
    <div onChange={event => props.onChange(event)}>
      <div className='availability'>
        <input
          type='checkbox'
          hidden={!props.is_editable}
          disabled={!props.is_editable}
          defaultChecked={!props.available}
          name='available'
          className='not-available'
          label='n/a'
          onBlur={props.onBlur}
        />
        <span hidden={!props.is_editable && props.available}>&nbsp;n/a</span>
      </div>

      {props.available === true && (
        <input
          className='cell-value percent'
          type='number'
          id=''
          name='cell'
          hidden={!props.is_editable && !props.available}
          disabled={!props.is_editable}
          defaultValue={props.value || 0}
          placeholder='...'
          min='0'
          max={props.max_value || 99999999}
          step='1'
          onChange={evt => onInputChange(evt)}
          onKeyDown={evt => onKeyDown(evt)}
          onBlur={props.onBlur}
        />
      )}
    </div>
  )
}

function onKeyDown(evt) {
  // permit 0-9 keyboard or num pad, left or right arrow, backspace, tab or delete
  const key = evt.which || evt.keyCode || 0
  if (
    !(
      (key >= 48 && key <= 57) ||
      key === 65 || // a to permit cmd/ctrl+a
      key === 67 || // c to permit cmd/ctrl+c
      key === 86 || // v to permit cmd/ctrl+v
      key === 88 || // x to permit cmd/ctrl+x
      (key >= 96 && key <= 105) ||
      key === 8 ||
      key === 9 ||
      (key >= 37 && key <= 40) ||
      key === 46
    )
  ) {
    evt.preventDefault()
  } else {
    // Store in case need to roll back in onInputChange
    evt.target.originalValue = evt.target.value
  }
}

function onInputChange(evt) {
  if (!evt.target.value) {
    evt.target.value = '0'
  }

  const newValue = parseInt(evt.target.value, 10)
  const maxLimit = parseInt(evt.target.max, 10)
  const minLimit = parseInt(evt.target.min, 10)

  if (typeof newValue === 'number' && newValue <= maxLimit && newValue >= minLimit) {
    evt.target.value = newValue
  } else {
    evt.target.value = evt.target.originalValue
  }
}

export default Cell
